module.exports = "/images/pillBlueTag.png?42f734669a02ca4efd63ce40264a97eb";